module.exports = "https://cdn.dashboard.gifty.nl/5960/images/blueprint-bg.svg?8d3485b350f4f35dc835dd490110a63a";